import * as Bet from "../blocks/BettingHistory/components/Bets";
export const BetComponents = {
    Single: Bet.SingleBet,
    Combo: Bet.ComboBet,
    System: Bet.SystemBet,
    YourBet: Bet.YourBet,
    PulseBet: Bet.PulseBet,
    CastBet: Bet.CastBet,
    Teaser: Bet.TeaserBet
};
//# sourceMappingURL=BetComponentTypes.js.map